import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@features/ui';
import { cn } from '@lib/utils.ts';

interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
  className?: string;
}

export default function Pagination({
  current,
  total,
  onChange,
  className,
}: PaginationProps) {
  return (
    <div
      className={cn(
        'flex items-center space-x-4 text-sm font-medium',
        className
      )}
    >
      <Button
        className={`[&_svg]:!size-auto hover:text-white ${
          current === 1 ? 'text-gray-500 cursor-not-allowed' : ''
        }`}
        disabled={current === 1}
        variant={'ghost'}
        onClick={() => onChange(current - 1)}
      >
        <ChevronLeft size={20} />
      </Button>
      <span>
        {current} of {total}
      </span>
      <Button
        className={`[&_svg]:!size-auto hover:text-white ${
          current === total ? 'text-gray-500 cursor-not-allowed' : ''
        }`}
        disabled={current === total}
        variant={'ghost'}
        onClick={() => onChange(current + 1)}
      >
        <ChevronRight size={20} />
      </Button>
    </div>
  );
}
